import { arrayRemove } from '@datorama/akita';
import type { AxiosInstance } from 'axios';

interface DeleteAttachmentOptions {
   httpClient: AxiosInstance;
   version: string;
   entityName: string;
   store: any;
   entityId: number;
   entityAttachmentId: number;
   setError: (_error: any) => void;
   storeUpdaterFn?: (_entity: any, _entityAttachmentId: number) => void;
}

function getBaseUrl(): string {
   return (process.env.REACT_APP_DOMAIN ?? '').replace(/\/+$/, '');
}

export function getAttachmentDownloadUrlByEntity(entityType: string, entityId: number, params: URLSearchParams): string {
   return `${getBaseUrl()}/api/v2/attachments/${entityType}/${entityId}/attachments/download?${params.toString()}`;
}

export function getAttachmentDownloadUrl(attachmentId: number): string {
   return `${getBaseUrl()}/api/v2/attachments/${attachmentId}/download`;
}

/**
 * Deletes an attachment and updates the store.
 *
 * @param options An object containing all parameters needed for deleting an attachment.
 * @returns {Promise<void>}
 */
export async function deleteAttachmentHandler(options: DeleteAttachmentOptions): Promise<void> {
   const { httpClient, version, entityName, store, entityId, entityAttachmentId, setError, storeUpdaterFn } = options;

   try {
      await httpClient.delete(`/${version}/${entityName}/${entityId}/attachments/${entityAttachmentId}`);
      if (storeUpdaterFn) {
         store.update(entityId, (entity: any) => storeUpdaterFn(entity, entityAttachmentId));
      } else {
         store.update(entityId, ({ attachments }: { attachments: any[] }) => ({ attachments: arrayRemove(attachments, entityAttachmentId) }));
      }
   } catch (error) {
      setError(error);
   }
}
